import { render, staticRenderFns } from "./FerryZoneList.vue?vue&type=template&id=1e2a8c2a"
import script from "../../../controllers/custom/ferry_zone/ferry-zone-list.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/ferry_zone/ferry-zone-list.js?vue&type=script&lang=js&external"
import style0 from "./FerryZoneList.vue?vue&type=style&index=0&id=1e2a8c2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports